/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RecommendCodeBindPageItemVo } from './RecommendCodeBindPageItemVo';
import {
    RecommendCodeBindPageItemVoFromJSON,
    RecommendCodeBindPageItemVoFromJSONTyped,
    RecommendCodeBindPageItemVoToJSON,
    RecommendCodeBindPageItemVoToJSONTyped,
} from './RecommendCodeBindPageItemVo';

/**
 * 
 * @export
 * @interface PageDataRecommendCodeBindPageItemVo
 */
export interface PageDataRecommendCodeBindPageItemVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataRecommendCodeBindPageItemVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataRecommendCodeBindPageItemVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataRecommendCodeBindPageItemVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<RecommendCodeBindPageItemVo>}
     * @memberof PageDataRecommendCodeBindPageItemVo
     */
    records?: Array<RecommendCodeBindPageItemVo>;
}

/**
 * Check if a given object implements the PageDataRecommendCodeBindPageItemVo interface.
 */
export function instanceOfPageDataRecommendCodeBindPageItemVo(value: object): value is PageDataRecommendCodeBindPageItemVo {
    return true;
}

export function PageDataRecommendCodeBindPageItemVoFromJSON(json: any): PageDataRecommendCodeBindPageItemVo {
    return PageDataRecommendCodeBindPageItemVoFromJSONTyped(json, false);
}

export function PageDataRecommendCodeBindPageItemVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataRecommendCodeBindPageItemVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(RecommendCodeBindPageItemVoFromJSON)),
    };
}

export function PageDataRecommendCodeBindPageItemVoToJSON(json: any): PageDataRecommendCodeBindPageItemVo {
    return PageDataRecommendCodeBindPageItemVoToJSONTyped(json, false);
}

export function PageDataRecommendCodeBindPageItemVoToJSONTyped(value?: PageDataRecommendCodeBindPageItemVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(RecommendCodeBindPageItemVoToJSON)),
    };
}

